import React, { Component } from 'react';
import OwlCarousel from 'react-owl-carousel';
import { mobile } from "../../Services/Agent"
import "./Slider.scss"
import { push } from "../../Services/Analytics"

class Slider extends Component {
    constructor() {
        super();
        this.onChanged = this.onChanged.bind(this);
        this.state = {}
    }
    shouldComponentUpdate(props) {
        return false;
    }
    componentDidMount() {
        // if (mobile()) {
        window.dispatchEvent(new Event("resize"));
        // }
        if (this.props.sectionName) {
            console.log(this.owl.props.navContainerClass, window.document.querySelector(`.${this.props.sectionName} .${this.owl.props.navContainerClass} .right`));
            window.document.querySelector(`.${this.props.sectionName} .${this.owl.props.navContainerClass} .right`).addEventListener("click", () => {
                push(this.props.sectionName, "Navigation Clicked Right");
            })
            window.document.querySelector(`.${this.props.sectionName} .${this.owl.props.navContainerClass} .left`).addEventListener("click", () => {
                push(this.props.sectionName, "Navigation Clicked Left");
            })
        }
    }
    componentWillReceiveProps(nextProps) {
        this.owl.to(nextProps.currentSlide, 600);
    }
    onChanged(event) {
    }
    render() {
        return (
            <OwlCarousel
                className={`${this.props.sectionName} owl-theme`}
                startPosition={0}
                margin={0}
                nav={true}
                lazyLoad={true}
                dots={false}
                autoWidth={false}
                responsiveClass={true}
                loop={this.props.loop}
                ref={(owl) => this.owl = owl}
                navText={["", ""]}
                onChanged={this.onChanged}
                navContainerClass="controller"
                navClass={["arrow right", "arrow left"]}
                responsive={this.props.responsive}
            >
                {this.props.items}
            </OwlCarousel>
        );
    }
}

export default Slider;



// WEBPACK FOOTER //
// ./src/Components/Helpers/Slider/Slider.jsx